import {
  LimitedEditionOption,
  LimitedEditionProps,
} from '@services/MarppleShop/renderApp/pages/Main/views/LimitedEdition/LimitedEdition.ts';

export class LimitedEditionVisibleHelper {
  constructor(
    private readonly data: LimitedEditionProps,
    private readonly option: LimitedEditionOption,
  ) {}

  isArrowVisible(): boolean {
    return !this.option.is_mobile && this.data.products.length > 4;
  }

  isSeeMoreLinkVisible(): boolean {
    return this.option.is_see_more_link_visible ?? true;
  }

  isProgressBarVisible(): boolean {
    return !this.option.is_mobile && this.data.products.length > 4;
  }
}
